module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "generativeAI2.13235141.png";